import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {AppSettings} from '../models/AppSettings';
import {RicambiService} from '../service/ricambi.service';
import {UserService} from '../service/user.service';
@Component({
    selector: 'app-tws-login',
    templateUrl: './tws-login.component.html',
    styleUrls: ['./tws-login.component.css']
})
export class TwsLoginComponent implements OnInit {

    public email: string;
    public errore: boolean = false;
    public password: string;
    public sezioneLogin: string = "login";
    public testoErrore: string;
    public code: string;
    public password2: string;
    public infoIta: string;
    public infoEng: string;
    public auth:string;
    public puls:boolean=false;
    constructor(private userService: UserService, private route: ActivatedRoute, private ricambiService: RicambiService, private router: Router) {
        this.reset();
    }

    reset() {
        this.infoIta = "Gentile cliente, la informiamo che per accedere alla nuova area B2B " + this.area + " è necessario richiedere le nuove credenziali di accesso scrivendo all'indirizzo <a href=\"mailto:websupport@ghibliwirbel.com\">websupport@ghibliwirbel.com</a>, indicando la ragione sociale, il codice cliente e l' indirizzo email a cui inviare i nuovi dati.<br>Grazie e buon lavoro!";
        this.infoEng = "  Dear user, we would like to inform you that to access the new B2B area " + this.area + " it is necessary to ask for the new log-in information by writing to <a href=\"mailto:websupport@ghibliwirbel.com\">websupport@ghibliwirbel.com</a> including the following information: company name, client ID number and the email address to send all the access details.<br>Thank you, and good job!";
    }

    onSubmit() {
        if (this.email && this.password) {
            this.userService.login(this.email, this.password).subscribe((result) => {
                if (result['success']) {
                    this.ricambiService.resetCategorie();
                    this.router.navigate(['home']);
                    this.errore = false;
                } else {
                    if(result["sezione"]=="nuovaPasswordFromLogin"){
                        this.password="";
                        this.leggiData(result);
                    }else{
                        this.testoErrore = "Invalid username or password";
                        this.errore = true;
                    }
                }
            });
        }
    }
    ngOnInit() {
        let sezione: string = this.route.snapshot.params['id'];
        if (sezione && sezione == "reimposta") {
            this.infoReimposta();
            return;
        }
        if (sezione && sezione == "recupera") {
            this.infoRecupera();
            return;
        }
        let loggato: boolean = this.userService.isLoggedIn();
        if (loggato) {
            this.router.navigate(['home']);
        }
    }
    get sezione() {
        return AppSettings.sezione;
    }
    get area() {
        return AppSettings.getArea();
    }

    vaiRecupera() {
        this.router.navigate(['login/recupera']);
    }

    infoRecupera() {
        this.userService.infoRecupera().then(dati => this.leggiData(dati))
    }

    infoReimposta() {
        this.userService.infoReimposta().then(dati => this.leggiData(dati))
    }

    leggiData(dati: any) {
        this.sezioneLogin = dati["sezione"];
        this.infoIta = dati["testoIta"];
        this.infoEng = dati["testoEng"];
        this.testoErrore = dati["testoErrore"];
        this.errore = dati["errore"];
        this.puls=dati["login"];
        this.auth=dati["auth"];
    }

    inviaDatiRecupera() {
        if (this.email) {
            this.userService.invioRecupera(this.email).then(dati => this.leggiData(dati))
        }
    }
    inviaCodiceReimposta() {
        if (this.email && this.code) {
            this.userService.controlloReimposta(this.email, this.code).then(dati => this.leggiData(dati))
        }
    }

    inviaNuovaPassword() {
        if (this.email && this.code && this.password && this.password2) {
            if (this.password != this.password2) {
                this.errore = true;
                this.testoErrore = "Le password non coindicono/Different password";
                return;
            }
            this.userService.nuovaPassword(this.email, this.code, this.password, this.password2).then(dati => this.leggiData(dati))
        }
    }
    
    inviaNuovaPasswordAuth() {
        if (this.email && this.auth && this.password && this.password2) {
            if (this.password != this.password2) {
                this.errore = true;
                this.testoErrore = "Le password non coindicono/Different password";
                return;
            }
            this.userService.nuovaPasswordAuth(this.email, this.auth, this.password, this.password2).then(dati => this.leggiData(dati))
        }
    }

    goLogin() {
        this.sezioneLogin="login";
        this.reset();
        this.router.navigate(['login']);
    }

}



// WEBPACK FOOTER //
// ./src/app/tws-login/tws-login.component.ts